import {
  CHECKOUT_ADDRESS_TARGET_PAGE_CODE,
  TARGET_PAGE_CODE_PARAM,
  TARGET_PAGE_REDIRECT_PARAM,
} from './consts'

export type LoginOrigin =
  | 'cart_expired_auth'
  | 'cart_not_logged_in'
  | 'forced_login'
  | 'login_page'
  | 'protected_page_redirect'

type CartLoginOrigin = Extract<
  LoginOrigin,
  'cart_expired_auth' | 'cart_not_logged_in'
>

export const loginOriginIsCart = (
  origin: LoginOrigin,
): origin is CartLoginOrigin =>
  origin === 'cart_expired_auth' || origin === 'cart_not_logged_in'

export const resolveLoginOrigin = (
  searchParams: Pick<URLSearchParams, 'get'>,
): LoginOrigin => {
  const targetsCheckout =
    searchParams.get(TARGET_PAGE_CODE_PARAM) ===
    CHECKOUT_ADDRESS_TARGET_PAGE_CODE
  const redirect = searchParams.get(TARGET_PAGE_REDIRECT_PARAM)
  const hasCartRedirect = ['/nx/cart', '/nx/checkout'].some((path) =>
    redirect?.includes(path),
  )
  const isForcedLogin = searchParams.get('forceLogin') === 'true'

  if (isForcedLogin && (targetsCheckout || hasCartRedirect)) {
    return 'cart_expired_auth'
  }

  if (targetsCheckout) {
    return 'cart_not_logged_in'
  }

  if (redirect) {
    return 'protected_page_redirect'
  }

  return isForcedLogin ? 'forced_login' : 'login_page'
}
